import { DEFAULT_IMAGE_OBJECT } from '@/utils/constants';
import { useEffect, useState } from 'react';

function useSetImagesDescriptionModal(props) {
  const { productData, activeIdx, showImageDescModal } = props;
  const [images, setImages] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(
    productData?.variants?.[activeIdx] || []
  );

  useEffect(() => {
    setSelectedVariant(productData?.variants?.[activeIdx]);
  }, [activeIdx]);

  useEffect(() => {
    setInitialImages();
  }, [showImageDescModal, selectedVariant]);

  function setInitialImages() {
    let tempImages = [];
    if (productData?.variants?.length) {
      if (selectedVariant?.images && selectedVariant?.images?.length)
        tempImages = selectedVariant?.images.slice(0, selectedVariant?.images?.length);
    }
    if (productData?.images && productData?.images?.length) {
      productData?.images.forEach((imageItem) => {
        tempImages.push(imageItem);
      });
    }
    if (!tempImages?.length) tempImages.push(DEFAULT_IMAGE_OBJECT);
    setImages(tempImages);
  }

  return images;
}

export default useSetImagesDescriptionModal;
